import { z } from 'zod';

export const chatMentionSchema = z.object({
  entityId: z.string(),
  objectId: z.string().optional(),
  name: z.string(),
  type: z.string(),
  link: z.string().optional(),
});
export type ChatMention = z.infer<typeof chatMentionSchema>;

export const resolvedEntitySourceSchema = z.enum(['subject', 'mention', 'identification']);
export type ResolvedEntitySource = z.infer<typeof resolvedEntitySourceSchema>;

export const resolvedEntitySchema = z.object({
  id: z.string(),
  name: z.string(),
  type: z.string(),
  source: resolvedEntitySourceSchema,
});
export type ResolvedEntity = z.infer<typeof resolvedEntitySchema>;
